import { memo } from 'react';
import { VStack, Spacer } from '@cbhq/cds-web/layout';
import { ThemeProvider } from '@cbhq/cds-web/system';
import { TextHeadline } from '@cbhq/cds-web/typography';
import { jsx, jsxs } from 'react/jsx-runtime';
function FooterColumn({
  heading,
  children
}) {
  return /*#__PURE__*/jsx(ThemeProvider, {
    scale: "large",
    children: /*#__PURE__*/jsxs(VStack, {
      spacingStart: 0.5,
      spacingEnd: 0.5,
      children: [/*#__PURE__*/jsx(TextHeadline, {
        as: "h2",
        children: heading
      }), /*#__PURE__*/jsx(Spacer, {
        vertical: 1
      }), /*#__PURE__*/jsx(VStack, {
        as: "ul",
        gap: 0.5,
        spacing: 0,
        offsetTop: 0,
        offsetBottom: 0,
        style: {
          listStyleType: 'none'
        },
        children: children
      })]
    })
  });
}
const FooterColumn$1 = /*#__PURE__*/memo(FooterColumn);
export { FooterColumn$1 as default };
//# sourceMappingURL=FooterColumn.js.map
